<template>
    <el-dropdown
      split-button
      @click="onClickButton"
      @visible-change="onVisibleChange"
      @command="onDropdownItem">
    模板
    <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(each, index) in ticketTemplateList" :key="each.id" :command="'' + index" :title="each.content">{{each.name}}</el-dropdown-item>
        <el-dropdown-item class="help_0" :command="-1">帮助 (修改或添加模板)</el-dropdown-item>
    </el-dropdown-menu>
    </el-dropdown>
</template>

<style>
  .help_0 {
    margin-top:10px;
    margin-bottom:-10px;
    padding-top:5px;
    padding-bottom:5px;
    border-top:1px solid #E5E5E5;
    color:#8B7B8B;
  }
</style>

<script>
export default {
  name: "TicketTemplateSelect",

  data() {
      return {
          ticketTemplateList : []
      };
  },

  mounted: function() {
    var _this = this;
    sdk.TicketTemplateApi().listMyTemplateByTypeCached({
      type : 'Reply',
      page : { pageSize : 9999, orderBy : "`index` ASC" }
    }).then((res)=>{
      _this.ticketTemplateList = res.list;
    });
  },

  methods: {
      onVisibleChange() {
        setTimeout(function() {
          $(".el-dropdown-menu").css("z-index", 20090);
        }, 200);
      },

      onClickButton() {
          _message("鼠标指向右侧的下拉三角选择模板");
      },

      onDropdownItem(command) {
        if ( -1 == command ) {
          window.open("/ticket/h");
          return;
        }

        this.$emit('selected', this.ticketTemplateList[command]);
      }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketTemplateSelect.vue